"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapTemplate = void 0;
const index_js_1 = require("../lifecycle/index.js");
const index_js_2 = require("../clean-stores/index.js");
const index_js_3 = require("../map/index.js");
function mapTemplate(init) {
    let Template = (id, ...args) => {
        if (!Template.cache[id]) {
            Template.cache[id] = Template.build(id, ...args);
        }
        return Template.cache[id];
    };
    Template.build = (id, ...args) => {
        let store = (0, index_js_3.map)({ id });
        (0, index_js_1.onMount)(store, () => {
            let destroy;
            if (init)
                destroy = init(store, id, ...args);
            return () => {
                delete Template.cache[id];
                if (destroy)
                    destroy();
            };
        });
        return store;
    };
    Template.cache = {};
    if (process.env.NODE_ENV !== 'production') {
        Template[index_js_2.clean] = () => {
            for (let id in Template.cache) {
                Template.cache[id][index_js_2.clean]();
            }
            Template.cache = {};
        };
    }
    return Template;
}
exports.mapTemplate = mapTemplate;
